export default "__VITE_ASSET__ff5bb5b5__"